const reportResource = (() => {
    const _default_config = {
        "default_thresholds": {},
        "html_skeleton": {
            "table_divs": [],
            "headers": []
        },
        "criteriaLabels": {}
    };
    const init = (default_config, resource, resource_config) => {
        // console.log(resource);
        Object.assign(_default_config, default_config);
        Object.assign(_default_config, resource_config);
        _default_config.resource = resource;
        _default_config.transformedData = [];
        _default_config.criteriaLabels = {
            "revenue": {"label":"Revenue", "prefix":_default_config.body.currencySymbol},
            "expense": {"label":"Operating Expense", "prefix":_default_config.body.currencySymbol},
            "operating_profit": {"label":"Operating Profit", "prefix":_default_config.body.currencySymbol},
            "liability": {"label":"Liability", "prefix":_default_config.body.currencySymbol},
            "debt": {"label":"Debt Service", "prefix":_default_config.body.currencySymbol},
            "dscr": {"label":"DSCR", "prefix":""},
            "avg_daily_balance": {"label":"Monthly Avg. Daily Balance", "prefix":_default_config.body.currencySymbol},
            "no_of_days_with_negative_balance": {"label":"#Negative Balance Days", "prefix":""},
            "nsf_count": {"label":"# NSF", "prefix":""}
        };
        getThresholds().then(res => {
            display_monitoring();
        }, err => {
            analyserV2.addAlertBox("Threshold information not available for this resource!");
            console.log(err);
        })
    }

    const getThresholds = () => {
        return new Promise((resolve, reject) => {
            let api = {
                "type": "POST",
                "url": getV2URL( _default_config.widget_service_api, 'get_monitoring_thresholds', _default_config.slugs),
                "processData": false,
                "data": JSON.stringify({ "threshold_id": _default_config.body.config.report.monitoring_threshold_id }),
                "dataType": "json",
                "headers": {
                    "Content-Type": "application/json"
                }
            };
            try {
                HttpRequest(api, function(res, err){
                    initScript.toggleLoader(false, true);
                    if(!!_default_config.slugs){
                        res = responseV2Interceptor(res,_default_config.slugs['statements']);
                    }else{
                        res = responseInterceptor(res);
                    }
                    res = res && res.data ? res.data.data ? res.data.data : res.data : res;
                    // res = initScript.getObjectValue(res, "[0].data");
                    if (!initScript.isEmpty(res)) {
                        _default_config.default_thresholds = res;
                        resolve(res)
                    }
                    else{
                        reject(err)
                    }
                })   
            } catch (error) {
                reject(error)
            }
        })
    }

    const display_monitoring = () => {
        //Config table target row header etc
        configureTableDivs()
        //Build Relational Data
        _default_config.transformedData = transformData(_default_config.data);
        //Populate table
        populateTable();
        //set Legends
        setLegends();
    }

    const transformData = (data) => {
        let transformedData = [];
        let markerClass = {"breached": "red-marker", "warning": "orange-marker", "normal": "green-marker"};
        let markerTextClass = {"breached": "red-marker-text", "warning": "orange-marker-text", "normal": "green-marker-text"};
        for (const [index, criteria] of Object.entries(data.summary)) {
            let tuple = {};
            let prefix = _default_config.criteriaLabels[criteria.monitoring_criteria]["prefix"]
            tuple["monitoring_criteria"] = _default_config.criteriaLabels[criteria.monitoring_criteria]["label"];
            var defaultThreshold = filterThreshold(criteria.monitoring_criteria);
            tuple["parameter"] = `
                                    <span class="d-block">Value</span>
                                    <span class="d-block">Percentage Change*</span>
                                    <span class="d-block">Monthly Variance</span>
                                    <span class="d-block">Monthly Variance %</span>
            `;
            tuple["thresholds"] = `
                                    <span class="d-block">${prefix} ${initScript.separateNumberByComma(defaultThreshold.value)}</span>
                                    <span class="d-block">${defaultThreshold.percent_change}% or more ${defaultThreshold.percent_change_order}</span>
                                    <span class="d-block">${prefix} ${initScript.separateNumberByComma(defaultThreshold.monthly_variance)} or more ${defaultThreshold.monthly_variance_order}</span>
                                    <span class="d-block">${defaultThreshold.percent_variance}% or more ${defaultThreshold.percent_variance_order}</span>
            `;
            tuple["simple_average_before_funding"] = `<span class="d-block">${prefix} ${transformNegative(criteria.simple_average_before_funding)}</span><span class="d-block">&nbsp;</span><span class="d-block">&nbsp;</span><span class="d-block">&nbsp;</span>`;
            
            let valueStatus = getMarker(defaultThreshold.percent_change_order, criteria.current_status.percent_change, defaultThreshold.percent_change)
            let varianceStatus = getMarker(defaultThreshold.percent_variance_order, criteria.current_status.percent_variance, defaultThreshold.percent_variance)
            
            tuple["current_status"] = `
                                    <span class="d-block">&nbsp;</span>
                                    <span class="d-block ${markerClass[valueStatus]} mr-3">&nbsp;</span>
                                    <span class="d-block">&nbsp;</span>
                                    <span class="d-block ${markerClass[varianceStatus]} mr-3">&nbsp;</span>
            `;
            if(criteria["pre_funding"]){
                for (const [key, value] of Object.entries(criteria["pre_funding"])) {
                    valueStatus = getMarker(defaultThreshold.percent_change_order, value.percent_change, defaultThreshold.percent_change)
                    varianceStatus = getMarker(defaultThreshold.percent_variance_order, value.percent_variance, defaultThreshold.percent_variance)

                    tuple[value.month_year] = `<span class="d-block">${prefix} ${transformNegative(value.value)}</span>
                    <span class="d-block ${markerTextClass[valueStatus]}">${value.percent_change}%</span>
                    <span class="d-block">${prefix} ${value.monthly_variance?transformNegative(value.monthly_variance):"N/A"}</span>
                    <span class="d-block ${markerTextClass[varianceStatus]}">${value.percent_variance?value.percent_variance:"N/A"}%</span>`;
                }
            }
            if(criteria["funded"]){
                for (const [key, value] of Object.entries(criteria["funded"])) {
                    valueStatus = getMarker(defaultThreshold.percent_change_order, value.percent_change, defaultThreshold.percent_change)
                    varianceStatus = getMarker(defaultThreshold.percent_variance_order, value.percent_variance, defaultThreshold.percent_variance)

                    tuple[value.month_year] = `<span class="d-block">${prefix} ${transformNegative(value.value)}</span>
                    <span class="d-block ${markerTextClass[valueStatus]}">${value.percent_change}%</span>
                    <span class="d-block">${prefix} ${value.monthly_variance?transformNegative(value.monthly_variance):"N/A"}</span>
                    <span class="d-block ${markerTextClass[varianceStatus]}">${value.percent_variance?value.percent_variance:"N/A"}%</span>`;
                }
            }
            if(criteria["monitoring"]){
                for (const [key, value] of Object.entries(criteria["monitoring"])) {
                    valueStatus = getMarker(defaultThreshold.percent_change_order, value.percent_change, defaultThreshold.percent_change)
                    varianceStatus = getMarker(defaultThreshold.percent_variance_order, value.percent_variance, defaultThreshold.percent_variance)
                    
                    tuple[value.month_year] = `<span class="d-block">${prefix} ${transformNegative(value.value, criteria.monitoring_criteria)}</span>
                    <span class="d-block ${markerTextClass[valueStatus]}">${value.percent_change}%</span>
                    <span class="d-block">${prefix} ${value.monthly_variance?transformNegative(value.monthly_variance):"N/A"}</span>
                    <span class="d-block ${markerTextClass[varianceStatus]}">${value.percent_variance?value.percent_variance:"N/A"}%</span>`;
                }
            }
            transformedData.push(tuple)
        }
        return transformedData;
    }

    const transformNegative = (n, label ="") => {
        return (n < 0)?`(${initScript.separateNumberByComma(-1*n)})`:initScript.separateNumberByComma(n);
    }

    const filterThreshold = (key) => {
        return _default_config.default_thresholds.thresholds.find(e => e.criteria === key).values
    }

    const getMarker = (order, currentValue, defaultValue) => {
        if(order === "increase"){
            if(currentValue >= defaultValue){
                return "breached";
            }
            else if (currentValue < defaultValue && currentValue > 0){
                return "warning";
            }
            else return "normal";
        }
        else if (order === "decrease"){
            defaultValue = -1 * defaultValue;
            if(currentValue <= defaultValue){
                return "breached";
            }
            else if (currentValue > defaultValue && currentValue < 0){
                return "warning";
            }
            else return "normal";
        }
    }

    const configureTableDivs = () => {
        _default_config.html_skeleton = {
            "table_divs": [
                {
                    "target": {
                        "header": "dataLeft-fixed-monitoring0",
                        "row": "dataLeft-fixed-monitoring0"
                    },
                    "columns": ["monitoring_criteria"]
                },
                {
                    "target": {
                        "header": "dataLeft-fixed-monitoring1",
                        "row": "dataLeft-fixed-monitoring1"
                    },
                    "columns": ["parameter"]
                },
                {
                    "target": {
                        "header": "dataLeft-fixed-monitoring2",
                        "row": "dataLeft-fixed-monitoring2"
                    },
                    "columns": ["thresholds"]
                },
                {
                    "target": {
                        "header": "dataLeft-fixed-monitoring3",
                        "row": "dataLeft-fixed-monitoring3"
                    },
                    "columns": ["simple_average_before_funding"]
                },
                {
                    "target": {
                        "header": "dataLeft-fixed-monitoring4",
                        "row": "dataLeft-fixed-monitoring4"
                    },
                    "columns": ["current_status"]
                },
                {
                    "target": {
                        "header": "data-head-monitoring",
                        "row": "mid-panel-monitoring"
                    },
                    "row_parent": {
                        "class": "data-row",
                    },
                }
            ],
            "headers": Object.keys(_default_config.body.config.report.columns)
        }
        Object.assign(_default_config.html_skeleton, _default_config.body.config.report)
        if(!_default_config.body.config.report.monitoringLast){
            for(const [x,v] of Object.entries(_default_config.data.months)){
                floating_headers_columns(x)
            }
        }
        else{
            for (var x = _default_config.data.months.length - 1; x >= 0; x--) {
                floating_headers_columns(x)
            }
        }
    }

    const floating_headers_columns = (x) => {
        _default_config.html_skeleton.headers.push(_default_config.data.months[x])
        _default_config.html_skeleton.columns[_default_config.data.months[x]] = {
            "value": _default_config.data.months[x],
            "config": {
                "header": {
                    "class": "label-block font-sb",
                },
                "row": {
                    "class": "label-block d-block p-2"
                }
            }
        }
    }

    const populateTable = () => {
        var BAS_config = {};
        BAS_config["table_divs"] = _default_config.html_skeleton.table_divs;
        BAS_config["data"] = _default_config.transformedData; //templateUtil.getColumnWiseData();
        BAS_config["body"] = { "class": _default_config.body.class };
        BAS_config["headers"] = _default_config.html_skeleton.headers;
        BAS_config.table_divs[5].columns = initScript.removeUnexpectedElements(_default_config.html_skeleton.headers, ["monitoring_criteria", "parameter", "thresholds", "simple_average_before_funding", "current_status"]);
        BAS_config["columns"] = _default_config.html_skeleton.columns;
        templateUtil.appendTabelHeaders(BAS_config);
        templateUtil.appendTabelRows(BAS_config);
        simulateHeader();
    }

    const simulateHeader = () => {
        var divClose = "</div>"
        var headerHtml = [];
        if (_default_config.data.summary[0].pre_funding) {
            for (var i = _default_config.data.summary[0].pre_funding.length - 1; i >= 0; i--) {
                // let pivot = (_default_config.data.summary[0].pre_funding.length % 2 != 0) ? parseInt(_default_config.data.summary[0].pre_funding.length / 2) : (parseInt(_default_config.data.summary[0].pre_funding.length / 2) + 1);
                let pivot = parseInt(_default_config.data.summary[0].pre_funding.length / 2)
                if (i == pivot) {
                    headerHtml.push(`<div class="label-block pre-funded-legend">PreFunding` + divClose);
                }
                else {
                    headerHtml.push(`<div class="label-block pre-funded-legend">` + divClose);
                }
            }
        }
        if (_default_config.data.summary[0].funded) {
            for (var i = _default_config.data.summary[0].funded.length - 1; i >= 0; i--) {
                // let pivot = (_default_config.data.summary[0].funded.length % 2 != 0) ? parseInt(_default_config.data.summary[0].funded.length / 2) : parseInt((_default_config.data.summary[0].funded.length / 2) + 1);
                let pivot = parseInt(_default_config.data.summary[0].funded.length / 2)
                if (i == pivot) {
                    headerHtml.push(`<div class="label-block funded-legend">Funded` + divClose);
                }
                else {
                    headerHtml.push(`<div class="label-block funded-legend">` + divClose);
                }
            }
        }
        if (_default_config.data.summary[0].monitoring) {
            for (var i = _default_config.data.summary[0].monitoring.length - 1; i >= 0; i--) {
                // let pivot = (_default_config.data.summary[0].monitoring.length % 2 != 0) ? parseInt(_default_config.data.summary[0].monitoring.length / 2) : parseInt((_default_config.data.summary[0].monitoring.length / 2) + 1);
                let pivot = parseInt(_default_config.data.summary[0].monitoring.length / 2)
                if (i == pivot) {
                    headerHtml.push(`<div class="label-block monitoring-legend">Monitoring` + divClose);
                }
                else {
                    headerHtml.push(`<div class="label-block monitoring-legend">` + divClose);
                }
            }
        }
        if(!_default_config.body.config.report.monitoringLast){
            headerHtml = headerHtml.reverse()
        }

        $('#pre-funded').html(headerHtml.join(""));
        $('#pre-funded-monitoring-labels').on('scroll', function () {
            $('#monitoring_rows').scrollLeft($(this).scrollLeft());
        });
        $('#monitoring_rows').on('scroll', function () {
            $('#pre-funded-monitoring-labels').scrollLeft($(this).scrollLeft());
        });
    }

    const setLegends = () => {
        //Create & Insert Information & Legends html
        let fundedDate = _default_config.body.funded_month?_default_config.body.funded_month:"Not Funded";
        let html = `
        <div class="wgt-funded-date">
            <span class="funded-date-label pane">
                <b>Funded Month:</b> <span class="funded-date">${fundedDate}</span>
            </span>
            <a id="paneHideShow" href="javascript:void(0);" class="btn btn-sm btn-success" style="float:right;font-size: 14px;padding: 0px 4px;font-weight: 600;border-radius: 50%;">&gt;&lt;</a>
        </div>
        <div class="wgt-fund-type pane">
            <span><i class="pre-funded-legend brdr-lgd br50">&nbsp;&nbsp;&nbsp;</i> Pre-Funding</span>
            <span><i class="funded-legend brdr-lgd br50">&nbsp;&nbsp;&nbsp;</i> Funded</span>
            <span><i class="monitoring-legend brdr-lgd br50">&nbsp;&nbsp;&nbsp;</i> Monitoring</span>
        </div>
        `;
        $("#funding_legends_date").html(html);
        
        //Panel Shrink/Expand View
        $("#paneHideShow:not(.wgt-pane-bound)").addClass('wgt-pane-bound').on("click", function(e){
            $(".pane").slideToggle("fast");
            if($(this).html() === "&gt;&lt;") $(this).html("&lt;&gt;")
            else $(this).html("&gt;&lt;")

            if($(".shrinkExpandLegends").hasClass("col-7")){
                $(".shrinkExpandLegends").removeClass("col-7");
                $(".shrinkExpandLegends").addClass("col-1");
            } else {
                $(".shrinkExpandLegends").removeClass("col-1");
                $(".shrinkExpandLegends").addClass("col-7");
            }
            if($(".variable-header-monitoring").hasClass("col-5")){
                $(".variable-header-monitoring").removeClass("col-5");
                $(".variable-header-monitoring").addClass("col-11");
            } else {
                $(".variable-header-monitoring").removeClass("col-11");
                $(".variable-header-monitoring").addClass("col-5");
            }
        })
    }

    return {
        init
    };
})();